import React from 'react';
import AppConfig from "../../services/AppConfig";

interface Props {
    icon: JSX.Element;
	size?: 'large' | "medium";
	className?: string;
}

const RoundedIcon = ({ icon, size, className }: Props) => {
	return (
		<div className={`rounded-icon ${size ? size : "large"} ${className ?? ""}`}>
			{!AppConfig.isDarkMode() && <div className="ellipse"/>}
            {icon}
		</div>
	)
}

export default RoundedIcon;